import React from 'react';
import {Box, Tooltip, Typography} from "@mui/material";

export const HeaderOPTAdditionally = ({column, height}) => {
    return (
        <Tooltip arrow placement="bottom"
                 title={column.columnDef.header}>
            <Box sx={{
                writingMode: 'vertical-rl',
                transform: 'rotate(180deg)',
                display: 'flex',
                height: 150,
                padding: 0,

            }}>
                <Typography sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontWeight: 700,
                }}> {column.columnDef.header}</Typography>

            </Box>
        </Tooltip>
    );
};
export const HeaderOPT = ({column, height}) => {
    return (
        <Box sx={{
            whiteSpace: 'pre-wrap',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-start',
            height: 150,
            padding: 0,
        }}>
            {column.columnDef.header}
        </Box>
    );
};


